var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"400px","height":"180px"},attrs:{"id":'chatMap'+_vm.index}})}
var staticRenderFns = []

export { render, staticRenderFns }